import axios from "axios";
import settings from "../settings";

let new_export_invoice = {
    is_new: true,
    invoice_date: null,
    arrival_date: null,
    payroll_date: null,
    client_name: null,
    manager_name: null,
    total_net: null,
    total_profit: null,
    total_arrived: null,
    percent: null,
    is_active: null,
    comment: null,
    rows: [],
    odoo_link: null,
    transport: []
};

let new_transport_row = {
    id: null,
    delivery_date: new Date().toLocaleDateString("en-CA"),
    terms_of_delivery: null,
    cargo_type: null,
    carrier_company: null,
    additional_terms: null
};
let new_export_invoice_row = {
    is_new: true,
    product_id: null,
    product_name: null,
    sale_price: null,
    sum: null,
    amount: null,
    own_price: null,
    profit: null
};
const listSettingsColumns = [
    {
        text: "Invoice date",
        align: "left",
        value: "invoice_date",
        isSelected: true
    },
    {
        text: "Country",
        align: "left",
        value: "client_country",
        isSelected: true
    },
    {
        text: "Flag",
        align: "left",
        value: "flag",
        isSelected: true
    },
    {
        text: "Client",
        align: "left",
        value: "client_name",
        isSelected: true
    },
    {
        value: "total_net",
        text: "Sum",
        align: "left",
        isSelected: true
    },
    {
        value: "total_profit",
        text: "Profit",
        align: "left",
        isSelected: true
    },
    {
        text: "Confirmed sum",
        align: "left",
        value: "total_arrived",
        isSelected: true
    },
    {
        text: "Marginal",
        align: "left",
        value: "marginal",
        isSelected: true
    },
    {
        value: "manager_name",
        text: "Manager",
        align: "left",
        isSelected: true
    },
    {
        text: "Payroll date",
        align: "left",
        value: "payroll_date",
        isSelected: true
    },
    {
        value: "arrival",
        text: "Arrival days",
        align: "left",
        isSelected: true
    },
    {
        value: "percent",
        text: "Percent",
        align: "left",
        isSelected: true
    },
    {
        value: "is_active",
        text: "Approved",
        align: "left",
        isSelected: true
    },
    {
        text: "Actions",
        align: "end",
        value: "actions",
        isSelected: true,
        sortable:false
    }
];
let initialState = {
    loadingExportInvoiceList: false,
    loadingExportInvoiceData: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    exportInvoices: [],
    activeExportInvoice: {},
    activeExportInvoiceRow: {},
    errorMessage: "",
    searchInvoiceString: "",
    tableOptions: null,
    exportInvoiceDialog: false,
    calculatedValues: [],
    exportInvoiceCloneDialog: false,
    activeClientChart: [],
    listSettingsModal: false,
    listSettingsColumns: listSettingsColumns,
    exportInvoiceTableHeaders: [],
    files: [],
    imageFileDialog: false
};
export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getExportInvoices({ commit, dispatch, state }, { options = null, search = null }) {
            commit("setExportInvoiceListLoading", true);
            try {
                let params = {
                    search: search,
                    page: options && options.page ? options.page : null,
                    itemsPerPage: options && options.itemsPerPage ? options.itemsPerPage : null,
                    sortBy: options && options.sortBy[0] ? options.sortBy[0] : null,
                    sortDesc: options && options.sortDesc ? options.sortDesc[0] : null
                };
                let response = await axios.get(settings.api_url + "/export-sales-invoices/", { params });
                if (response && response.data && response.data.success === 1) {
                    let data = response.data;
                    commit("addExportInvoice", data.invoices);
                    if (data.user_export_invoice_search_settings) {
                        commit("setMountedTableHeaders", data.user_export_invoice_search_settings);
                    } else {
                        commit("setExportInvoiceTableHeaders");
                    }
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setExportInvoiceListLoading", false);
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                commit("setExportInvoiceListLoading", false);
            }
        },
        async callGetExportInvoices({ state, dispatch, commit }) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            await dispatch("getExportInvoices", {
                options: state.tableOptions,
                search: state.searchInvoiceString
            });
            await dispatch("calculateTotals");
        },
        async getExportInvoiceData({ commit }, invoiceId) {
            commit("setExportInvoiceDataLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/export-sale-invoice/" + invoiceId);
                if (response && response.data && response.data.success === 1) {
                    let data = response.data;
                    commit("setActiveExportInvoice", data.invoice_data);
                    commit("setActiveClientChartData", data.client_chart);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setExportInvoiceDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                commit("setExportInvoiceDataLoading", false);
            }
        },
        async sendExportInvoice({ commit, dispatch }, payload) {
            commit("setRequestSuccess", false);
            commit("setExportInvoiceListLoading", true);
            try {
                let result = await axios.post(settings.api_url + "/export-sale-invoice/", payload);
                if (result && result.data && result.data.success === 1) {
                    await commit("resetActiveExportInvoice");
                    await dispatch("callGetExportInvoices");
                    commit("setRequestSuccess", true);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setExportInvoiceListLoading", false);
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                commit("setExportInvoiceListLoading", false);
            }
        },
        async calculateTotals({ state, commit }) {
            let array = [];
            let categories = state.exportInvoices
                .map(x => x.category)
                .filter((value, index, self) => self.indexOf(value) === index);
            for (let i in categories) {
                let filteredArray = state.exportInvoices.filter(x => x.category === categories[i]);
                let total_net = filteredArray.map(x => x.total_net).reduce((a, b) => a + b);
                let total_profit = filteredArray.map(x => x.total_profit).reduce((a, b) => a + b);
                let total_arrived = filteredArray.map(x => x.total_arrived).reduce((a, b) => a + b);
                let percent = filteredArray.map(x => (x.percent / 100) * x.total_net).reduce((a, b) => a + b);
                let data = {
                    category: categories[i],
                    total_net: total_net,
                    total_profit: total_profit,
                    total_arrived: total_arrived,
                    percent: percent
                };
                array.push(data);
            }
            commit("setCalculatedValues", array);
        },
        async createDuplicate({ commit, dispatch }, payload) {
            commit("setExportInvoiceListLoading", true);
            try {
                let params = {
                    ...payload,
                    act: "duplicate"
                };
                let response = await axios.put(settings.api_url + "/export-sale-invoice/", params);
                if (response && response.data && response.data.success === 1) {
                    commit("resetActiveExportInvoice");
                    await dispatch("callGetExportInvoices");
                    commit("setRequestSuccess", true);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setActiveExportInvoice", {});
                commit("setExportInvoiceListLoading", false);
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                commit("setExportInvoiceListLoading", false);
            }
        },
        async updateSalesInvoicesRowsExportPriceProperty({ commit }, product_id) {
            try {
                return await axios.post(settings.api_url + "/update-export-sales-invoices-rows/" + product_id);
            } catch (e) {
                console.log(e);
            }
        },
        async deleteInvoice({ commit, dispatch }, invoice) {
            commit("setExportInvoiceListLoading", true);
            try {
                let response = await axios.delete(settings.api_url + "/export-sale-invoice/", {
                    params: invoice
                });
                if (response && response.data && response.data.success === 1) {
                    await dispatch("callGetExportInvoices");
                    commit("setRequestSuccess", true);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setExportInvoiceListLoading", false);
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                commit("setExportInvoiceListLoading", false);
            }
        },
        async updateInvoicePrices({ commit, dispatch }, { invoice_id }) {
            await commit("setExportInvoiceListLoading", true);
            try {
                let payload = {
                    invoice_id: invoice_id,
                    act: "update-prices"
                };
                let response = await axios.put(settings.api_url + "/export-sale-invoice/", payload);
                if (response && response.data && response.data.success === 1) {
                    await commit("setRequestSuccess", true);
                } else {
                    await commit("setRequestError", true);
                    await commit("setErrorMessage", "Failed");
                }
                await commit("setExportInvoiceListLoading", false);
            } catch (e) {
                console.log(e);
                await commit("setRequestError", true);
                await commit("setErrorMessage", "Failed");
                await commit("setExportInvoiceListLoading", false);
            }
        },
        async sendNewComment({ commit, dispatch, state }, comment) {
            commit("setExportInvoiceDataLoading", true);
            try {
                let params = { comment: comment, export_sale_invoice_id: state.activeExportInvoice.id };
                let response = await axios.post(settings.api_url + "/export-sale-invoice-comment/", params);
                if (response && response.data && response.data.success === 1) {
                    state.activeExportInvoice.comments = response.data.comments;
                    commit("setRequestSuccess", true);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setExportInvoiceDataLoading", false);
                return response.data;
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                commit("setExportInvoiceDataLoading", false);
            }
        },
        async deleteComment({ commit, state }, comment_id) {
            commit("setExportInvoiceDataLoading", true);
            try {
                let response = await axios.delete(settings.api_url + "/export-sale-invoice-comment/" + comment_id);
                if (response && response.data && response.data.success === 1) {
                    state.activeExportInvoice.comments = response.data.comments;
                    commit("setRequestSuccess", true);
                } else {
                    state.activeExportInvoice.comments = [{ comment: "Something went wrong." }];
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setExportInvoiceDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                commit("setExportInvoiceListLoading", false);
            }
        },
        async submitFileUpdate({ commit, dispatch }, { invoice, files }) {
            let formData = new FormData();
            await files.map((f, idx) => {
                formData.append("files[" + idx + "]", f);
            });

            await formData.append("related_id", JSON.stringify(invoice.id));
            await formData.append("related_type", JSON.stringify("export_sale_invoice"));
            commit("setRequestSuccess", false);
            try {
                let response = await axios.post(settings.api_url + "/file", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                if (response.status === 200) {
                    await dispatch("callGetExportInvoices");
                    await dispatch("getExportInvoiceData", invoice.id);
                    commit("setRequestSuccess", true);
                    commit("resetFiles");
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        },
        async removeFile({ commit, dispatch }, { file_id, invoice_id }) {
            commit("setRequestSuccess", false);
            try {
                let response = await axios.delete(settings.api_url + "/file?file_id=" + file_id);
                if (response.status === 200) {
                    await dispatch("getExportInvoiceData", invoice_id);
                    commit("setRequestSuccess", true);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        }
    },
    mutations: {
        setTableOptions(state, options) {
            state.tableOptions = options;
            this.dispatch("ExportSaleInvoiceStore/callGetExportInvoices");
        },
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        addExportInvoice(state, exportInvoices) {
            state.exportInvoices = exportInvoices;
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        setExportInvoiceListLoading(state, value) {
            state.loadingExportInvoiceList = value;
        },
        editExportInvoiceProp(state, payload) {
            state.activeExportInvoice = payload.invoice;
            state.activeExportInvoice = {
                ...state.activeExportInvoice,
                [payload.prop]: payload.value
            };
            this.dispatch("ExportSaleInvoiceStore/sendExportInvoice", state.activeExportInvoice);
        },
        updateActiveExportInvoiceProperty(state, { prop, value }) {
            state.activeExportInvoice = {
                ...state.activeExportInvoice,
                [prop]: value
            };
        },
        updateActiveExportInvoiceTransportProperty(state, { prop, value, index }) {
            state.activeExportInvoice.transports[index] = {
                ...state.activeExportInvoice.transports[index],
                [prop]: value
            };
        },
        addNewActiveExportInvoiceTransportRow(state) {
            state.activeExportInvoice.transports.push({ ...new_transport_row });
        },
        removeActiveExportInvoiceTransportRow(state, index) {
            state.activeExportInvoice.transports.splice(index, 1);
        },
        addActiveExportInvoice(state) {
            state.activeExportInvoice = { ...new_export_invoice, rows: [], transports: [] };
        },
        setExportInvoiceDialog(state, bool) {
            state.exportInvoiceDialog = bool;
        },
        updateActiveExportInvoiceRowProperty(state, { prop, value, index }) {
            state.activeExportInvoice.rows[index] = {
                ...state.activeExportInvoice.rows[index],
                [prop]: value
            };
        },
        setCalculatedValues(state, value) {
            state.calculatedValues = value;
        },
        setActiveExportInvoice(state, invoice) {
            state.activeExportInvoice = invoice;
        },
        setExportInvoiceCloneDialog(state, bool) {
            state.exportInvoiceCloneDialog = bool;
        },
        setExportInvoiceDataLoading(state, bool) {
            state.loadingExportInvoiceData = bool;
        },
        addNewActiveExportInvoiceRow(state) {
            state.activeExportInvoice.rows.push({
                ...new_export_invoice_row,
                id: Math.floor(Math.random() * 10000)
            });
        },
        addCopyActiveExportInvoiceRow(state, item) {
            state.activeExportInvoice.rows.push({ ...item, id: item.id + "_1", is_new: true });
        },
        deleteActiveExportInvoiceRow(state, index) {
            state.activeExportInvoice.rows.splice(index, 1);
        },
        resetActiveExportInvoice(state) {
            state.drawerOpen = false;
            state.activeExportInvoiceRow = {};
            state.activeExportInvoice = {};
        },
        setActiveClientChartData(state, value) {
            state.activeClientChart = value;
        },
        updateInvoiceSearch(state, payload) {
            state.searchInvoiceString = payload.term;
            this.dispatch("ExportSaleInvoiceStore/callGetExportInvoices", {
                options: state.tableOptions,
                search: state.searchInvoiceString
            });
        },
        resetInvoiceSearch(state) {
            state.searchInvoiceString = "";
        },
        setExportInvoiceTableHeaders(state) {
            state.exportInvoiceTableHeaders = [];
            state.listSettingsColumns.map(x => {
                if (x.isSelected) {
                    x.align = "left";
                    state.exportInvoiceTableHeaders.push(x);
                }
            });
            let length = state.exportInvoiceTableHeaders.length;
            if (length > 2) {
                state.exportInvoiceTableHeaders[length - 1].align = "center";
                state.exportInvoiceTableHeaders[length - 2].align = "end";
            }
        },
        setMountedTableHeaders(state, value) {
            state.exportInvoiceTableHeaders = value;
            let selected_array = state.exportInvoiceTableHeaders.map(x => x.value);
            state.listSettingsColumns.forEach(x => {
                x.isSelected = selected_array.includes(x.value);
            });
        },
        toggleListSettingsColumn(state, item) {
            let column = state.listSettingsColumns.find(c => c.value === item.value);
            column.isSelected = !column.isSelected;
        },
        toggleListSettingsModal(state) {
            state.listSettingsModal = !state.listSettingsModal;
        },
        setFiles(state, payload) {
            state.files = payload.value;
        },
        resetFiles(state) {
            state.files = [];
        },
        setImageFileDialog(state, bool) {
            state.imageFileDialog = bool;
        }
    },
    getters: {
        invoiceCount: state => {
            return state.exportInvoices.length;
        }
    }
};
